import React, { memo, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

// styles
import './style.scss';


import useDeviceDetect from 'utils/useDeviceDetect';
import { useWaveSurfer } from 'utils/hooks';




const MediaPlayer2 = ({ key, type, url, date, className, duration, isBlob, blobFile, ...rest }) => {
  const childClassNames = classNames(`media-player-wrapper ${type}`, className);
  const { isMobile } = useDeviceDetect();

  const waveformRef = useRef(null);
//  const wavesurfer = useRef(null);

  const {
    waveSurferRef,
    onSetAudioRef,
    loadAudio,  isPlay, isPause, loading, onTogglePlayPause } = useWaveSurfer(waveformRef.current);

  useEffect(() => {
    !!waveformRef.current && onSetAudioRef(waveformRef.current);
  },[])

  // create new WaveSurfer instance
  // On component mount and when url changes
  useEffect(() => {
    if (!!url && waveformRef.current) {
      onSetAudioRef(waveformRef.current, url);
    }
  }, [url]);

  const formatTime = time => {
    return [
      Math.floor((time % 3600) / 60), // minutes
      ('00' + Math.floor(time % 60)).slice(-2), // seconds
    ].join(':');
  };

  return (
    url && (
      <div className={childClassNames} {...rest}>
        {type === 'big' && isMobile && (
          <span className="waveform-data">{moment(date).format('ll')}</span>
        )}

        <div
          id={`waveform-container-${new Date().getTime()}`}
          className="waveform-container"
        >
          <div
            id={`waveform-play-${new Date().getTime()}`}
            className={`play-btn ${
              isMobile && type === 'big' ? 'preview-btn' : ''
            }`}
            onClick={onTogglePlayPause}
          >
            <span className={`play-pause-icon play`} />
          </div>

          <div
            id={`waveform-${new Date().getTime()}`}
            className={`waveform ${
              isMobile && type === 'big' ? 'mobile-big' : ''
            }`}
            ref={waveformRef}
          />
        </div>
        <div className="waveform-details">
          {type === 'small' && !!date && (
            <span className="waveform-data">{moment(date).format('ll')} -</span>
          )}
          {isPlay && (
            <span className="waveform-current-time">0:00</span>
          )}
          {!!duration && <span className="waveform-duration">{formatTime(duration)}</span>}
        </div>
      </div>
    )
  );
};

MediaPlayer2.defaultProps = {
  type: 'small',
  isBlob: false,
  duration: false,
};

MediaPlayer2.propTypes = {
  type: PropTypes.oneOf(['big', 'small', 'feed']).isRequired,
  date: PropTypes.string,
  url: PropTypes.string.isRequired,
};

export default memo(MediaPlayer2);
